import { render } from "./Alert.vue?vue&type=template&id=f1344816"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/alert/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1344816"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1344816', __exports__)) {
    api.reload('f1344816', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=f1344816", () => {
    api.rerender('f1344816', render)
  })

}


export default __exports__